import { render, staticRenderFns } from "./ReturnInformation.vue?vue&type=template&id=733361b2&scoped=true&"
import script from "./ReturnInformation.vue?vue&type=script&lang=js&"
export * from "./ReturnInformation.vue?vue&type=script&lang=js&"
import style0 from "./ReturnInformation.vue?vue&type=style&index=0&id=733361b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733361b2",
  null
  
)

export default component.exports